<template>
  <div class="query__div" @keydown.enter="submit">
    <el-input maxlength='450' v-model="query.code" :placeholder="ph" style="margin-right: 20px; width: 250px"/>
  </div>
</template>

<script>
export default {
  name: "ScanQuery_largeBagMark",
  props: {
    ph: String,
    print: Boolean,
    isRetain: Boolean,//保留输入框内信息
    keyText: String,
  },
  data() {
    return {
      query: {
        code: '',
        isPrint: !!this.print
      }
    }
  },
  methods: {
    submit: function () {
      const { code, isPrint } = this.query
      this.query = {
        code: this.isRetain ? this.query.code : '',
        isPrint
      }
      this.$emit('onQuery', {
        code, isPrint
      })
    }
  }
}
</script>

<style scoped>
.query__div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0;
}
</style>
